import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { getOrderStateTag } from 'app/order/fns';
import { OrderService } from 'app/order/state/order.service';

@Component({
    selector: 'app-settlement-period-switch',
    standalone: true,
    templateUrl: './settlement-period-switch.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettlementPeriodSwitchComponent {
    private orderService = inject(OrderService);
    protected hasMonthlySettlementPeriod = getOrderStateTag('hasMonthlySettlementPeriod') as Signal<boolean>;

    protected toggleSettlementPeriod(monthly: boolean): void {
        this.orderService.setTag('hasMonthlySettlementPeriod', monthly);
    }
}
